"use client";

import { $api } from "@/lib/api-client";

/**
 * Whether the site is currently in maintenance mode.
 *
 * Split out of useMaintenanceCheck so the flag has one reader rather than two.
 * That hook redirects; this one answers the question, and anything that needs
 * to hide UI during maintenance can ask without also inheriting a redirect.
 *
 * Both callers share the same query key, so React Query dedupes them into a
 * single poll no matter how many components subscribe.
 *
 * `=== "true"` matches the backend exactly (MaintenanceGuard reads the same
 * string). Loosening it here — truthiness, case-insensitive compare — would let
 * the UI and the API disagree about whether the site is frozen.
 */
export function useIsMaintenanceMode(): boolean {
  const { data } = $api.useQuery(
    "get",
    "/settings/{name}",
    { params: { path: { name: "maintenance_mode" } } },
    { refetchInterval: 60_000, staleTime: 60_000 },
  );

  return data?.data?.value === "true";
}
